import { inputClass } from '../AuthCard.tsx';
import type { EditProps, ViewProps } from './types.ts';

export function MetricGridView({ content }: ViewProps<'metric_grid'>) {
  if (content.items.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {content.items.map((item, i) => (
        <div key={i} className="break-inside-avoid rounded-lg border border-gray-200 p-3">
          <p className="text-xs font-medium tracking-wide text-gray-400 uppercase">{item.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-800">{item.value}</p>
          {item.note && <p className="mt-0.5 text-xs text-gray-500">{item.note}</p>}
        </div>
      ))}
    </div>
  );
}

export function MetricGridEdit({ content, onChange }: EditProps<'metric_grid'>) {
  const setItem = (i: number, patch: Partial<(typeof content.items)[number]>) =>
    onChange({
      ...content,
      items: content.items.map((item, j) => (j === i ? { ...item, ...patch } : item)),
    });
  return (
    <div className="space-y-2">
      {content.items.map((item, i) => (
        <div key={i} className="flex gap-2">
          <input
            className={inputClass}
            placeholder="Label"
            value={item.label}
            onChange={(e) => setItem(i, { label: e.target.value })}
          />
          <input
            className={inputClass}
            placeholder="Value (e.g. €250k)"
            value={item.value}
            onChange={(e) => setItem(i, { value: e.target.value })}
          />
          <input
            className={inputClass}
            placeholder="Note (optional)"
            value={item.note ?? ''}
            onChange={(e) => setItem(i, { note: e.target.value || undefined })}
          />
          <button
            type="button"
            className="text-sm whitespace-nowrap text-red-500 hover:underline"
            onClick={() =>
              onChange({ ...content, items: content.items.filter((_, j) => j !== i) })
            }
          >
            Remove
          </button>
        </div>
      ))}
      <button
        type="button"
        className="text-sm text-blue-600 hover:underline"
        onClick={() =>
          onChange({ ...content, items: [...content.items, { label: '', value: '' }] })
        }
      >
        Add metric
      </button>
    </div>
  );
}
